import {
    CAMBIAR_ESTADO_DISPOSITIVO_REQUEST,
    CAMBIAR_ESTADO_DISPOSITIVO_SUCCESS,
    CAMBIAR_ESTADO_DISPOSITIVO_ERROR,
    GET_ESTADO_DISPOSITIVOS_REQUEST,
    GET_ESTADO_DISPOSITIVOS_SUCCESS,
    GET_ESTADO_DISPOSITIVOS_ERROR,
    CONFIGURAR_ALWAYS_ON_REQUEST,
    CONFIGURAR_ALWAYS_ON_SUCCESS,
    CONFIGURAR_ALWAYS_ON_ERROR,
    CAMBIO_ESTADO_MASIVO_REQUEST,
    CAMBIO_ESTADO_MASIVO_SUCCESS,
    CAMBIO_ESTADO_MASIVO_ERROR
} from '../actions/types';

const initialState = {
    dispositivos: {},
    dispositivosProyecto: [],
    loading: false,
    error: null,
    ultimoCambio: null,
    estadoMasivo: {
        loading: false,
        ultimoResultado: null
    }
};

const dispositivosReducer = (state = initialState, action) => {
    switch (action.type) {
        case CAMBIAR_ESTADO_DISPOSITIVO_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case CAMBIAR_ESTADO_DISPOSITIVO_SUCCESS: {
            const { tipo, dispositivo, sensoresAfectados = [] } = action.payload;
            const nuevosDispositivos = { ...state.dispositivos };
            
            // Actualizar dispositivo principal
            nuevosDispositivos[dispositivo.id] = {
                ...dispositivo,
                tipo
            };
            
            // Actualizar sensores afectados (en caso de tarjeta)
            sensoresAfectados.forEach(sensor => {
                nuevosDispositivos[sensor.id] = {
                    ...sensor,
                    tipo: 'sensor'
                };
            });

            return {
                ...state,
                loading: false,
                dispositivos: nuevosDispositivos,
                ultimoCambio: {
                    tipo,
                    dispositivo,
                    sensoresAfectados,
                    timestamp: new Date()
                },
                error: null
            };
        }

        case CAMBIAR_ESTADO_DISPOSITIVO_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case GET_ESTADO_DISPOSITIVOS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_ESTADO_DISPOSITIVOS_SUCCESS:
            return {
                ...state,
                loading: false,
                dispositivosProyecto: action.payload,
                error: null
            };

        case GET_ESTADO_DISPOSITIVOS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case CAMBIO_ESTADO_MASIVO_REQUEST:
            return {
                ...state,
                estadoMasivo: {
                    ...state.estadoMasivo,
                    loading: true
                },
                error: null
            };

        case CAMBIO_ESTADO_MASIVO_SUCCESS:
            return {
                ...state,
                estadoMasivo: {
                    loading: false,
                    ultimoResultado: action.payload
                },
                error: null
            };

        case CAMBIO_ESTADO_MASIVO_ERROR:
            return {
                ...state,
                estadoMasivo: {
                    ...state.estadoMasivo,
                    loading: false
                },
                error: action.payload
            };

        case CONFIGURAR_ALWAYS_ON_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case CONFIGURAR_ALWAYS_ON_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };

        case CONFIGURAR_ALWAYS_ON_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default dispositivosReducer;
